import React, { useState } from "react";
import { CRMColors } from "../../models/CRMColors";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMIcon } from "../CRMIcon/CRMIcon";
import { CRMParagraph } from "../Simple/CRMParagraph/CRMParagraph";
import { WeightSemiBold } from "../WeightSemiBold/WeightSemiBold";
import { Absolute } from "../BuildingBlocks/Absolute";
import { Background } from "../BuildingBlocks/Background";
import { Relative } from "../BuildingBlocks/Relative";
import { SpacingColumn } from "../BuildingBlocks/SpacingColumn";
import { CursorPointer } from "../CursorPointer/CursorPointer";

export type TCodecEditFormFieldHelp = {
    whereToLook: string;
    searchFor: string | null;
};

export const CRMCodecEditFormFieldHelp = (props: React.PropsWithChildren<{
    help: TCodecEditFormFieldHelp;
}>): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Relative width="100%">
            <SpacingColumn spacing={CRMSpacing.TINY}>
                {/* Reserves the gutter the icon is absolutely positioned into. Without it a
                    long label runs underneath the icon instead of wrapping before it. */}
                <Background padding="0px 24px 0px 0px">
                    {props.children}
                </Background>

                {isOpen &&
                    <Background
                        padding="8px"
                        color={CRMColors.HIGHLIGHTS_CALMING_PINK_12}
                        borderRadius="5px"
                    >
                        <SpacingColumn spacing={CRMSpacing.TINY}>
                            <CRMParagraph>
                                <WeightSemiBold>Where to look:</WeightSemiBold>&nbsp;{props.help.whereToLook}
                            </CRMParagraph>

                            {props.help.searchFor !== null &&
                                <CRMParagraph>
                                    <WeightSemiBold>Search for:</WeightSemiBold>&nbsp;“{props.help.searchFor}”
                                </CRMParagraph>
                            }
                        </SpacingColumn>
                    </Background>
                }
            </SpacingColumn>

            <Absolute top="0px" right="0px">
                <CursorPointer
                    title="How do I find this?"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <CRMIcon
                        iconName="question-in-circle"
                        size="tiny"
                        colour="hex"
                        hexColour={isOpen
                            ? CRMColors.HIGHLIGHTS_CALMING_PINK_0
                            : CRMColors.NEUTRAL_4
                        }
                    />
                </CursorPointer>
            </Absolute>
        </Relative>
    );
};
